import { render, staticRenderFns } from "./UnitSelect.vue?vue&type=template&id=1054fd9f"
import script from "./UnitSelect.vue?vue&type=script&lang=js"
export * from "./UnitSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports